import { ItemType } from './loot.js';
export const MSG_BUILD_MODE_TOGGLE = 'build_mode_toggle';
export const MSG_BUILD_PLACE = 'build_place';
export const MSG_BUILD_REMOVE = 'build_remove';
export const MSG_BUILD_STATE = 'build_state';
export const MSG_BUILD_RESULT = 'build_result';
export const MSG_BUILD_BLOCK_PLACED = 'build_block_placed';
export const MSG_BUILD_BLOCK_REMOVED = 'build_block_removed';
export const MSG_BUILD_CURRENCY_SYNC = 'build_currency_sync';
export const BUILD_PROTOCOL_VERSION = 1;
export const BUILD_BLOCK_SIZE_PX = 32;
export const BUILD_BLOCK_COST_SECONDS = 30;
export const BUILD_CURRENCY_ACCRUAL_SECONDS = 10;
export const BUILD_REQUIRED_ITEM = ItemType.MaterialWood;
//# sourceMappingURL=playerBuild.js.map